import { ModalProvider } from '@leroy-merlin-br/backyard-react'

import reactComponentLoader from 'scripts/react-component-loader'

import { Payment } from 'checkout/pages/Payment'
import { UserInvalid } from 'checkout/components/Disclaimers'
import { CouponAvailable } from 'checkout/components/CouponAvailable'
import { BankSlipInstallments } from 'checkout/components/BankSlipInstallments'
import { Pix } from 'checkout/pages/Success/Pix'
import { DiscountsInfoOpenButton } from 'checkout/components/DiscountsModal/components'

import { CouponAlertMessage } from '../shared/components'
import { CheckoutModal } from './components/CheckoutModal'

const PixApp = props => {
  const shippingInformation = JSON.parse(props.shippingInformation)

  return <Pix {...props} shippingInformation={shippingInformation} />
}

const Modal = props => {
  return (
    <ModalProvider>
      <CheckoutModal {...props} />
    </ModalProvider>
  )
}

const DiscountInfoIconModalProvider = ({ ...props }) => (
  <ModalProvider>
    <DiscountsInfoOpenButton {...props} />
  </ModalProvider>
)

const CouponAlertMessageProvider = () => (
  <CouponAlertMessage />
)

reactComponentLoader(PixApp, '[data-success-pix]')
reactComponentLoader(Modal, '[data-checkout-modal]')
reactComponentLoader(Payment, '[data-checkout-payment]')
reactComponentLoader(UserInvalid, '[data-checkout-disclaimer-user-invalid]')
reactComponentLoader(CouponAvailable, '[data-checkout-coupon-available]')
reactComponentLoader(
  BankSlipInstallments,
  '[data-checkout-bank-slip-installments]'
)
reactComponentLoader(DiscountInfoIconModalProvider, '[data-discount-info-icon]')
reactComponentLoader(CouponAlertMessageProvider, '[data-coupon-alert-message]')
